import { render, staticRenderFns } from "./personAfilTable.vue?vue&type=template&id=7c4d479e&scoped=true&"
import script from "./personAfilTable.vue?vue&type=script&lang=js&"
export * from "./personAfilTable.vue?vue&type=script&lang=js&"
import style0 from "./personAfilTable.vue?vue&type=style&index=0&id=7c4d479e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4d479e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c4d479e')) {
      api.createRecord('7c4d479e', component.options)
    } else {
      api.reload('7c4d479e', component.options)
    }
    module.hot.accept("./personAfilTable.vue?vue&type=template&id=7c4d479e&scoped=true&", function () {
      api.rerender('7c4d479e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/ui/person-afil/personAfilTable.vue"
export default component.exports